module.exports = __webpack_public_path__ + "components/roadsurfer/static/roadsurfer-1200@2x-b215971f0941c0da339a9cd3a6c500db.webp";